import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'notify-component',
  templateUrl: './notify.component.html',
})
export class AppNotifyComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}

  get icon() {
    switch (this.data.type) {
      case 'success':
        return 'done';
      case 'error':
        return 'error';
      case 'warn':
        return 'warning';
      case 'info':
        return 'info';
    }
    return '';
  }
}
